import React from "react";
import PropTypes from "prop-types";
import { PaginationTable } from "@nike/epic-react-ui";

const SearchableTable = ({ columns, data }) => {
  /* eslint-disable */
  // We disable this because react-table handles all the key logic
  return (
    <div>
      <PaginationTable
        data={data}
        columns={columns}
        isCompact={true}
        pageSizeOptions={[10, 25, 50]}
        withSearchBar={true}
      />
    </div>
  );
  /* eslint-enable */
};

SearchableTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object)
};

export default SearchableTable;
